/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';

import EnvironmentModel from 'cio/models/environment';

interface LanguageAttributeSelectArgs {
  environment: EnvironmentModel;
  disabled?: boolean;
  onChange: (value: string) => unknown;
}

export default class LanguageAttributeSelect extends Component<LanguageAttributeSelectArgs> {
  get options() {
    let currentLanguageAttribute = this.args.environment.languageAttribute;
    let options = this.args.environment.sentAttributes.map((attribute) => ({
      label: attribute,
      value: attribute,
    }));

    if (
      isPresent(currentLanguageAttribute) &&
      options.findIndex((option) => option.value === currentLanguageAttribute) === -1
    ) {
      options = [{ label: currentLanguageAttribute, value: currentLanguageAttribute }, ...options];
    }

    return options;
  }
}
